export default function KpiCard({ label, value, unit, sub, icon: Icon, accent = false, testId, onClick }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      disabled={!onClick}
      className={`text-left bg-[#12141D] border ${accent ? "border-[#00D4FF]/60" : "border-border"}
        p-5 flex flex-col gap-3 relative group transition-colors w-full
        ${onClick ? "cursor-pointer hover:border-[#00D4FF]" : "cursor-default"}`}
    >
      <div className="flex items-center justify-between">
        <span className="text-[10px] tracking-[0.3em] uppercase text-[#94A3B8] font-semibold">{label}</span>
        {Icon && (
          <div className="h-8 w-8 border border-border bg-[#0A0B10] flex items-center justify-center text-[#00D4FF]">
            <Icon size={16} />
          </div>
        )}
      </div>
      <div className="flex items-baseline gap-2">
        <div className="font-heading font-bold text-3xl tabular-nums tracking-tight">{value}</div>
        {unit && <div className="text-xs text-muted-foreground uppercase tracking-wider">{unit}</div>}
      </div>
      {sub && (
        <div
          data-testid={testId ? `${testId}-sub` : undefined}
          className="inline-flex self-start items-center gap-1.5 px-2.5 py-1 bg-[#0A0B10] border-l-2 border-[#00D4FF] text-[13px] font-mono font-semibold text-white/90 tabular-nums"
        >
          {sub}
        </div>
      )}
      <div className="h-[1px] w-8 bg-[#00D4FF]" />
      {onClick && (
        <span className="absolute top-2 right-2 text-[9px] tracking-widest text-[#00D4FF] opacity-0 group-hover:opacity-100 transition-opacity">
          DRILL →
        </span>
      )}
    </button>
  );
}
